export const getNumbers = value => {
  return value.replace(/\D/g, '');
};